// Access state of an engine model for the current user (MOOV-5543). A model opts in by declaring
// `canAccess: vm => boolean`; models without it are always 'granted', so existing screens are unaffected.
// While the profile is still loading the role checks can't be trusted yet, hence 'pending'.
export function resolveModelAccess(vm, model) {
  if (!model || typeof model.canAccess !== 'function') {
    return 'granted'
  }
  const profile = vm.$store.getters.profile
  if (!profile || !profile.roles) {
    return 'pending'
  }
  return model.canAccess(vm) ? 'granted' : 'denied'
}
